export default "__VITE_ASSET__BAQKfhe3__"